import React from 'react';
import cx from 'classnames';
import ReactTooltip from 'react-tooltip';

import {ICON_FINISHED, ICON_IN_PRODUCTION, ICON_NOT_STARTED, LINE_LENGTH} from './constants';
import Icon from './components/Icon';
import styles from './styles.module.scss';

interface Props {
    stage: {
        stageName: string;
        showName: string;
        titleClassName: string;
        inProduction: boolean;
        finished: boolean;
        first: boolean;
        last: boolean;
    };
    smallSize?: boolean;
}

function State({stage, smallSize}: Props) {
    const {inProduction, finished, stageName, showName, titleClassName, first, last} = stage;

    let icon = ICON_NOT_STARTED;
    if (inProduction) {
        icon = ICON_IN_PRODUCTION;
    } else if (finished) {
        icon = ICON_FINISHED;
    }

    return (
        <div
            key={stageName}
            className={cx(
                {[styles.extremes]: first || last, [styles.middles]: !first && !last},
                {[styles.container]: !smallSize, 'column reverse': smallSize}
            )}
        >
            <h3 className={titleClassName}></h3>
            <div className={cx({[styles.production]: inProduction}, `row middle ${styles.state}`)}>
                <svg
                    className={cx({
                        [styles.extremLine]: first,
                        [styles.line]: !first,
                        [styles.finishedLine]: finished || inProduction,
                    })}
                >
                    <line x1="0" y1="0" x2={first ? '0' : LINE_LENGTH} y2="0"/>
                </svg>
                <a href='#' data-tip={showName}>
                    <Icon icon={icon.svg} className={icon.className}/>
                    <ReactTooltip/>
                </a>
                <svg className={cx({
                    [styles.line]: true,
                    [styles.finishedLine]: finished && !last,
                })}>
                    <line x1="0" y1="0" x2={last ? '0' : LINE_LENGTH} y2="0"/>
                </svg>
            </div>
        </div>
    );
}

export default State;
